
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"icons","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"id":"cross","d":"M8 6.73l4.46-4.47a.91.91 0 111.28 1.28L9.27 8l4.47 4.46a.91.91 0 11-1.28 1.28L8 9.27l-4.46 4.47a.91.91 0 11-1.28-1.28L6.73 8 2.26 3.54a.91.91 0 011.28-1.28L8 6.73z"}})])
          )
        }
      }
    